module.exports = __webpack_public_path__ + "img/sale.a3274fc0.png";